import homeSaga from './sagas';

export default [homeSaga()];
